import { render, staticRenderFns } from "./TouchpointInfo.vue?vue&type=template&id=72a48051&scoped=true&"
import script from "./TouchpointInfo.vue?vue&type=script&lang=js&"
export * from "./TouchpointInfo.vue?vue&type=script&lang=js&"
import style0 from "./TouchpointInfo.vue?vue&type=style&index=0&id=72a48051&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a48051",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72a48051')) {
      api.createRecord('72a48051', component.options)
    } else {
      api.reload('72a48051', component.options)
    }
    module.hot.accept("./TouchpointInfo.vue?vue&type=template&id=72a48051&scoped=true&", function () {
      api.rerender('72a48051', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Charts/SankeyV2/TouchPointInfo/TouchpointInfo.vue"
export default component.exports